// extracted by mini-css-extract-plugin
module.exports = {"slider":"CustomSlider_slider__2zxMY","slick-next":"CustomSlider_slick-next__opngN"};